
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { getCustomerTagList, addCustomerTag, editCustomerTag, delCustomerTag } from '../../api/customer';

@Component({
  name: 'SettingTemplateTags',
  components: {

  }
})
export default class extends Vue {
  private pagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };
  private tableData = []
  private addOneTagsVisible = false
  private formTags:any= {
    id: '',
    name: ''
  }
  private addSubTagsVisible = false
  private formSubTags: any = {
    first: '',
    firstId: '',
    second: '',
    id: ''
  }
  created() {
    this.getTagsList();
  }

  private addOneHandle() {
    this.formTags = {};
    this.addOneTagsVisible = true;
  }
  private editOneHandle(row:any) {
    this.formTags.id = row.id;
    this.formTags.name = row.name;
    this.addOneTagsVisible = true;
  }
  private delOneHandle(row:any) {
    this.$confirm('是否删除?', '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.delTags(row.id);
      })
      .catch(() => {});
  }
  private oneDialogHandle() {
    if (!this.formTags.name) {
      this.showErrorMsg('请输入一级客户标识');
      return;
    }
    if (this.formTags.id) {
      this.addTags(this.formTags.id, '', this.formTags.name);
    } else {
      this.addTags('', '', this.formTags.name);
    }
  }

  private editSubHandle(row:any) {
    this.formSubTags.first = row.pname;
    this.formSubTags.firstId = row.pid;
    this.formSubTags.second = row.name;
    this.formSubTags.id = row.id;
    this.addSubTagsVisible = true;
  }
  private addSubTagsHandle(row:any) {
    this.formSubTags.first = row.name;
    this.formSubTags.firstId = row.id;
    this.formSubTags.second = '';
    this.formSubTags.id = '';
    this.addSubTagsVisible = true;
  }
  private delSubTagsHandle(row:any) {
    this.$confirm('是否删除?', '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.delTags(row.id);
      })
      .catch(() => {});
  }
  private subDialogHandle() {
    if (!this.formSubTags.second) {
      this.showErrorMsg('请输入一级客户标识');
      return;
    }
    if (this.formSubTags.id) {
      this.addTags(this.formSubTags.id, this.formSubTags.firstId, this.formSubTags.second);
    } else {
      this.addTags('', this.formSubTags.firstId, this.formSubTags.second);
    }
  }
  private handleCurrentChange(page:number) {
    this.pagination.currentPage = page;
    this.getTagsList();
  }
  private handlePageSizeChange(size:number) {
    this.pagination.pageSize = size;
    this.getTagsList();
  }
  private getTagsList() {
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };
    getCustomerTagList(params).then(res => {
      if (res.data) {
        this.tableData = res.data.list;
        this.pagination.total = res.data.count;
      } else {
        this.tableData = [];
      }
    }).catch(err => {
      let msg = err.msg;
      this.tableData = [];
    });
  }
  private addTags(tagsId:any, pid:any, name: any) {
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };
    if (name) {
      params.name = name;
    }
    if (pid) {
      params.pid = pid;
    }
    if (tagsId) {
      params.customer_tag_id = tagsId;
      editCustomerTag(params).then(res => {
        this.showSuccessMsg((res as any).msg);
        this.getTagsList();
        this.addOneTagsVisible = false;
        this.addSubTagsVisible = false;
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    } else {
      addCustomerTag(params).then(res => {
        this.showSuccessMsg((res as any).msg);
        this.getTagsList();
        this.addOneTagsVisible = false;
        this.addSubTagsVisible = false;
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }
  }
  private delTags(tagsId:any) {
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };
    params.customer_tag_id = tagsId;
    delCustomerTag(params).then(res => {
      this.showSuccessMsg((res as any).msg);
      this.getTagsList();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
